
import React from 'react';

export const CreditsConfirmationEmail = ({
  userName,
  credits,
  amount,
  currency,
}: {
  userName: string;
  credits: number;
  amount: number;
  currency: string;
}) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Konfirmim i Blerjes së Krediteve</title>
</head>
<body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="text-align: center; margin-bottom: 30px;">
    <h1 style="color: #4F46E5;">Konfirmim i Blerjes së Krediteve</h1>
  </div>
  
  <div style="background-color: #f9f9f9; border-radius: 5px; padding: 20px; margin-bottom: 20px;">
    <h2 style="color: #1F2937;">Detajet e Blerjes</h2>
    <p>I/E nderuar ${userName},</p>
    <p>Faleminderit për blerjen e krediteve në platformën tonë!</p>
    <p><strong>Kredite të Blera:</strong> ${credits}</p>
    <p><strong>Çmimi Total:</strong> ${amount.toFixed(2)} ${currency}</p>
    <p>Kreditet janë shtuar në llogarinë tuaj dhe mund t'i përdorni për të krijuar shpallje të reja.</p>
  </div>

  <div style="margin-top: 30px; text-align: center; color: #666;">
    <p>Faleminderit që përdorni shërbimet tona!</p>
    <p>© ${new Date().getFullYear()} Treguim.org</p>
  </div>
</body>
</html>
  `;
};
